import { render, staticRenderFns } from "./EarnReciept.vue?vue&type=template&id=aa912f4e&scoped=true"
import script from "./EarnReciept.vue?vue&type=script&lang=js"
export * from "./EarnReciept.vue?vue&type=script&lang=js"
import style0 from "./EarnReciept.vue?vue&type=style&index=0&id=aa912f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa912f4e",
  null
  
)

export default component.exports